import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Slider from 'react-slick';
import ActionTile from './ActionTile';
import { actionTileActions, modalActions, participantProfileActions, riScenarioActions } from '../../redux/root-action';
import { analyticsTracking, modals } from '../../utils/constants';
import { formatAmountWithoutDecimals } from '../../utils/helpers';
import { getSuggestedTotalContribution, getSuggestedContributionAsJson } from 'selectors';

const StyledDot = styled.div`
  width: 8px;
  height: 8px;
  background-color: #b4babf;
  border-radius: 50%;
`;

const StyledSliderContainer = styled.div`
  margin-top: -30px;
  .slick-dots {
    margin: 0 0px 24px 0px;
    bottom: auto;
  }
  .slick-dots li {
    height: auto;
    width: auto;
    margin: 0px 4px;
  }
  .slick-dots .slick-active .active {
    background-color: #05c3de;
  }
`;

let spouseText = '';
let listOfNQPlans: any = [];

class ActionTiles extends Component {
  props: any;

  componentDidMount() {
    const { fetchPlans, fetchActionTiles, fetchRIScenario } = this.props;
    fetchActionTiles();
    fetchPlans();
    //fetchRIScenario();
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    const {  plans } = this.props;
    let prevPropsPlanNumber = null,
      propsPlanNumber = null;

    if (prevProps.plans.length) {
      prevPropsPlanNumber = prevProps.plans[0].planNumber;
    }
    if (plans && plans.length) {
      propsPlanNumber = plans[0].planNumber;
    }
  }

  showTermedModal = () => {
    const { showModal } = this.props;
    showModal(modals.TERMED_MODAL);
  };

  getUpdatedActionTiles = () => {
    const {
      actionTiles,
      simulationCurrentWant: { simulationType, adviceContributionRate },
      showModal,
      accounts = [],
      suggestedTotalContribution,
      suggestedContributionData,
      spouseProfile,
    } = this.props;

    let isTermed = false;
    let termedCount = 0;
    let outsideAccounts = 0;
    listOfNQPlans = [];

    accounts.map((account: any) => {
      if (account.status == 'TERMINATED') {
        termedCount++;
      }

      if (account.planNumber === null && account.clientNumber === null) {
        outsideAccounts++;
      }

      if (
        account.displayAccountCategory == 'RPSNQAccountSummary' ||
        account.displayAccountCategory == 'NonQualAccountSummary' ||
        account.displayAccountCategory == 'RPSNQTRACAccountSummary'
      ) {
        listOfNQPlans.push(account);
      }

      return true;
    });
    // console.log({
    //   accounts,
    //   listOfNQPlans,
    // });

    if (termedCount === accounts.length - outsideAccounts) {
      isTermed = true;
    }
    if (spouseProfile && spouseProfile.bpId) {
      spouseText = ' and spouse info';
    } else {
      spouseText = '';
    }

    const currentBalance = accounts.reduce((accum: number, account: any) => {
      const balance = account.balance >= 0 ? account.balance : account.amount;
      return accum + (account.includeInScenario ? Number(balance) : 0);
    }, 0);

    const pensionAccounts = accounts.reduce(
      (accum: number, account: any) => accum + (account.categoryName === 'Pension' ? 1 : 0),
      0,
    );

    const noOfAccounts = accounts.length - pensionAccounts;

    if (!actionTiles) {
      return [];
    }

    const updatedActionTiles: Array<Record<string, any>> = [];

    actionTiles.forEach(({ elements: { tileHeader, tileCopy, tileSubheader, tileId } }: any) => {
      switch (tileId.value) {
        case 'GREAT_MOVE_TERMED_MESSAGE':
          if (isTermed && accounts.length != listOfNQPlans.length) {
            updatedActionTiles.push({
              tileHeader: tileHeader.value,
              tileSubheader: tileSubheader.value,
              tileCopy: tileCopy.value,
              tileOnClick: () => showModal(modals.TERMED_MODAL),
              linkText: 'Learn more',
              handleLinkClick: () => showModal(modals.TERMED_MODAL),
              analyticsId: analyticsTracking.RIXActionTileKnowYourOptions,
            });
          }
          break;
        case 'GREAT_MOVE_ON_TRACK_GENERIC_MESSAGE':
          if (
            simulationType &&
            adviceContributionRate &&
            !isTermed &&
            suggestedTotalContribution === 0 &&
            accounts.length != listOfNQPlans.length
          ) {
            updatedActionTiles.push({
              tileHeader: tileHeader.value,
              tileSubheader: tileSubheader.value,
              tileCopy: tileCopy.value,
              tileOnClick: () => showModal(modals.INCREASE_CONTRIBUTION),
              linkText: 'Learn more',
              handleLinkClick: () => showModal(modals.INCREASE_CONTRIBUTION),
              analyticsId: analyticsTracking.RIXActionTileContributions,
            });
          }
          break;
        case 'GREAT_MOVE_OFF_TRACK_SPECIFIC_MESSAGE':
          if (
            simulationType &&
            adviceContributionRate &&
            !isTermed &&
            suggestedTotalContribution &&
            !suggestedContributionData.hasMixedUnit &&
            accounts.length != listOfNQPlans.length
          ) {
            updatedActionTiles.push({
              tileHeader: tileHeader.value,
              tileSubheader: tileSubheader.value,
              tileCopy: tileCopy.value.replace('#VALUE#', suggestedTotalContribution),
              tileOnClick: () => showModal(modals.INCREASE_CONTRIBUTION),
              linkText: 'Learn more',
              handleLinkClick: () => showModal(modals.INCREASE_CONTRIBUTION),
              analyticsId: analyticsTracking.RIXActionTileContributions,
            });
          }
          break;
        case 'GREAT_MOVE_OFF_TRACK_GENERIC_MESSAGE':
          if (
            ((simulationType && !adviceContributionRate && !isTermed) ||
              (simulationType &&
                adviceContributionRate &&
                !isTermed &&
                suggestedTotalContribution &&
                suggestedContributionData.hasMixedUnit)) &&
            accounts.length != listOfNQPlans.length
          ) {
            updatedActionTiles.push({
              tileHeader: tileHeader.value,
              tileSubheader: tileSubheader.value,
              tileCopy: tileCopy.value,
              tileOnClick: () => showModal(modals.INCREASE_CONTRIBUTION),
              linkText: 'Learn more',
              handleLinkClick: () => showModal(modals.INCREASE_CONTRIBUTION),
              analyticsId: analyticsTracking.RIXActionTileContributions,
            });
          }
          break;
        case 'GOOD_STEP_GENERIC_MESSAGE':
          updatedActionTiles.push({
            tileHeader: tileHeader.value,
            tileSubheader: tileSubheader.value,
            tileCopy: tileCopy.value,
            tileOnClick: () => showModal(modals.DELAY_RETIREMENT),
            linkText: 'Learn more',
            handleLinkClick: () => showModal(modals.DELAY_RETIREMENT),
            analyticsId: analyticsTracking.RIXActionTileDelayRetirement,
          });
          break;
        case 'SOMETHING_TO_CONSIDER_MESSAGE':
          updatedActionTiles.push({
            tileHeader: tileHeader.value,
            tileSubheader: 'Add/edit account or spouse info.',
            tileCopy: `You have ${noOfAccounts} account${noOfAccounts !== 1 ? 's' : ''}${spouseText}.`,
            tileOnClick: () => showModal(modals.ADD_ACCOUNT_OR_SPOUSE),
            linkText: 'Add/Edit',
            handleLinkClick: () => showModal(modals.ADD_ACCOUNT_OR_SPOUSE),
            analyticsId: analyticsTracking.RIXActionTileAccountSpouse,
          });
          break;
        default:
      }
    });
    return updatedActionTiles;
  };

  render(): JSX.Element {
    const {
      simulationCurrentWant: { simulationType },
      simulationFailed,
    } = this.props;

    if (simulationType || simulationFailed) {
      return (
        <StyledSliderContainer id={`action-tiles-slider-container`}>
          <Slider
            speed={500}
            infinite={false}
            slidesToShow={3}
            slidesToScroll={3}
            dots={true}
            arrows={false}
            appendDots={dots => <ul>{dots}</ul>}
            customPaging={() => <StyledDot id={`action-tiles-dot`} className="active" />}
            responsive={[
              {
                breakpoint: 1025,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                },
              },
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                },
              },
            ]}
          >
            {this.getUpdatedActionTiles() &&
              this.getUpdatedActionTiles().map((tile: any, i: number) => (
                <ActionTile
                  key={i}
                  tileHeader={tile.tileHeader}
                  tileSubheader={tile.tileSubheader}
                  tileCopy={tile.tileCopy}
                  tileOnClick={tile.tileOnClick}
                  linkText={tile.linkText}
                  handleLinkClick={tile.handleLinkClick}
                  analyticsId={tile.analyticsId}
                />
              ))}
          </Slider>
        </StyledSliderContainer>
      );
    } else {
      return <React.Fragment></React.Fragment>;
    }
  }
}

const mapStateToProps = (state: any) => {
  const {
    participantProfile,
    actionTile,
    charts,
    contribution,
    account: {
      modelledScenario: { accounts },
    },
    riScenario,
  } = state;
  return {
    participantProfile: participantProfile.participantProfile,
    plans: participantProfile.plans,
    actionTiles: actionTile.data,
    simulationCurrentWant: charts.simulationCurrentWant,
    simulationFailed: charts.error.status && charts.error.stataus !== 200,
    contribution: contribution.originalContributions.contributions,
    accounts,
    suggestedTotalContribution: getSuggestedTotalContribution(state),
    suggestedContributionData: getSuggestedContributionAsJson(state),
    spouseProfile: riScenario.spouseProfile,
    contributionAccounts: riScenario.accounts,
  };
};

export default connect(mapStateToProps, {
  fetchActionTiles: actionTileActions.fetchActionTiles,
  fetchPlans: participantProfileActions.fetchPlans,
  showModal: modalActions.showModal,
  fetchRIScenario: riScenarioActions.fetchRIScenario,
})(ActionTiles);
